import './index.css';

import { BulkInviteProgressManager } from '@/components/actions/send-invitation/bulk-invite-progress-toast';
import { BulkEmailProgressManager } from '@/components/affiliate/bulk-email/BulkEmailProgressManager';
import { ExportProgressToast } from '@/components/exports/ExportProgressToast';
import { NotificationsTransmitBridge } from '@/components/notifications/NotificationsTransmitBridge';
import { AuthProvider } from '@/contexts/auth-context';
import { QueryClientProvider } from '@tanstack/react-query';
import { createDashboardQueryClient } from '@/libs/query-client';
import ErrorBoundary from './components/ErrorBoundary';
import { Provider } from './components/ui/provider';
import { Toaster } from './components/ui/toaster';
import { Router } from './Router';
import { ProductAnalyticsProvider } from './components/analytics/ProductAnalyticsProvider';

const queryClient = createDashboardQueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider forcedTheme="light">
        <ErrorBoundary>
          <AuthProvider>
            <ProductAnalyticsProvider>
              <Router />
              <Toaster />
              <BulkInviteProgressManager />
              <BulkEmailProgressManager />
              <ExportProgressToast />
              <NotificationsTransmitBridge />
            </ProductAnalyticsProvider>
          </AuthProvider>
        </ErrorBoundary>
      </Provider>
    </QueryClientProvider>
  );
}
